import {t} from '@lingui/macro'
import {toast} from 'react-hot-toast'

import {LocationModel} from '@/models/Location'

export const successCreateLocationToast = (location: LocationModel) =>
  toast.success(t`The tournament location „${location.name}“ were created`)
